module.exports = __webpack_public_path__ + "static/media/cardif-boton-cerrar.298e5020.svg";